import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {Link, Redirect, RouteComponentProps} from 'react-router-dom';
import {COMMON_NS} from '@intelingu/core/constants/base.constants';
import {lazyInject} from '@intelingu/core/IoC/container';
import {UserStore} from '@intelingu/core/stores/UserStore';
import withTranslation from '@intelingu/core/utils/withTranslation';
import {SocialButtons} from "../../../partials/SocialButtons";
import {LoginFormComponent} from "./LoginFormComponent";

export interface LoginPageProps extends RouteComponentProps<any> {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class LoginPage extends Component<LoginPageProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    render() {
        const { location, t } = this.props;

        if (this.userStore.user) {
            return <Redirect to={`/`} />
        }

        const alert = location.state && location.state.alert;

        return <div className={'session-page'}>
            <h1>{ t('sessionLogInWith') }:</h1>

            { alert && (
                <div className={'alert alert-primary'} style={{ marginTop: 20 }}>
                    { alert }
                </div>
            )}

            {/*<div className={'sep'} />

            <SocialButtons />

            <div className={'or'}>
                <span>{ t('sessionOr') }</span>
            </div>*/}

            <LoginFormComponent />

            <div className={'bottom-links'}>
                <Link to={'/session/reset'}>{ t('sessionForgotPasswordLink') }</Link>
                {/*<Link to={'/session/register'}>{ t('sessionRegisterNowLink') }</Link>*/}
            </div>
        </div>
    }

}
